// Fund account labels read "Fund Name - Legal Entity - Currency - Sage Code", but a lot of
// funds already carry the legal entity in their name ("… Fund - Germany"), which made the
// label repeat it. Only append the legal entity when the name does not already say it.

type FundAccountLike = {
  currency?: string | null
  sageCode?: string | null
  fund?: {
    name?: string | null
    legalEntity?: { name?: string | null } | null
  } | null
} | null

// Compare on words so a short entity name cannot match part of a longer word
// ("UK" must not count as present in "Ukraine Fund").
const words = (value: string): string =>
  ` ${value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()} `

export const fundNameIncludesLegalEntity = (
  fundName: string,
  legalEntityName: string
): boolean => {
  const entity = words(legalEntityName).trim()
  if (!entity) return true
  return words(fundName).includes(` ${entity} `)
}

export const fundAccountLabel = (
  fundAccount: FundAccountLike,
  { includeSageCode = true }: { includeSageCode?: boolean } = {}
): string => {
  if (!fundAccount) return ''

  const fundName = fundAccount.fund?.name ?? ''
  const legalEntityName = fundAccount.fund?.legalEntity?.name ?? ''
  const redundantLegalEntity =
    !legalEntityName ||
    (!!fundName && fundNameIncludesLegalEntity(fundName, legalEntityName))

  return [
    fundName,
    redundantLegalEntity ? undefined : legalEntityName,
    fundAccount.currency,
    includeSageCode ? fundAccount.sageCode : undefined,
  ]
    .filter(Boolean)
    .join(' - ')
}
